<app-modal
  [title]="'Discount code' | trans:'cart/discount-code-input-modal/header/title'"
  maxWidth="1200px"
  minWidth="30%"
  width="fit-content"
  [compact]="true"
>
  <ng-template>
    <div>
      <app-form-control
        label="{{ 'Code'| trans:'cart/discount-code-input-modal/code.Label' }}"
      >
        <input
          #codeInput
          type="text"
          [ngModel]="code()"
          (ngModelChange)="code.set($event)"
          [disabled]="isLoading()"
          (keydown.enter)="onSubmit()"
          placeholder="{{ 'Enter discount code'| trans:'cart/discount-code-input-modal/code.Placeholder' }}"
          autocomplete="off"
          autocapitalize="characters"
          spellcheck="false"
        >
      </app-form-control>
    </div>
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-flex-end">
      <button
        class="button button--md button--primary-ghost text-uppercase"
        [disabled]="isLoading()"
        (click)="close()"
      >
        {{ 'Cancel'| trans:'cart/discount-code-input-modal/cancel.Button' }}
      </button>
      <button
        class="button button--md button--primary text-uppercase"
        [disabled]="!code().trim() || isLoading()"
        (click)="onSubmit()"
      >
        {{ 'Confirm'| trans:'cart/discount-code-input-modal/confirm.Button' }}
      </button>
    </div>
  </ng-container>
</app-modal>
